import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import {
    PreviousState,
    CurrentState,
    Reason,
    type ColumnsProps
} from "./State";
import Timeline from "./Timeline";
import Jsonable from "./Jsonable";

const Diff = (props: ColumnsProps) => (
    <Box
    >
        <Timeline>
            <PreviousState
                {...props}
            />
            <Reason
                {...props}
            />
            <CurrentState
                {...props}
            />
        </Timeline>
        <Divider
            sx={{
                mt: 3
            }}
        />
        <Jsonable
            {...props}
        />
    </Box>
);

export default Diff;
